<div class="authentication-bg min-vh-100">
  <div class="bg-overlay bg-white"></div>
  <!-- Language Switcher -->
  <div class="language-switcher-container">
    <app-language-switcher></app-language-switcher>
  </div>
  <div class="container">
    <div class="col-row">
      <div class="col-md-6">
        <div class="w-full">
          <div class="mb-4 mb-md-5 responsive-auth-header">
            <a routerLink="/" class="d-block auth-logo">
              <div class="d-flex gap-3">
                <img src="assets/images/HC-logo.svg" alt="HotelCard Logo" class="logo" />
                <img src="assets/images/hotelcard-text.svg" alt="HotelCard" class="hotelcard-text" />
                <span class="mt-3 responsive-divider">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="2"
                    height="30"
                    viewBox="0 0 2 30"
                    fill="none"
                  >
                    <path d="M1.24854 2.18557e-08L1.24853 30" stroke="white" />
                  </svg>
                </span>
                <span class="text-white extranet">Extranet</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column">
      <div class="row justify-content-center my-auto">
        <div class="col-lg-6">
          <div class="responsive-center-card responsive-auth-page-card">
            <div class="card auth-cover-card overflow-hidden">
              <div class="row g-0">
                <div class="col-lg-12">
                  <div class="login-form-card bg-white h-100 d-flex align-items-center justify-content-center auth-card">
                    <div class="w-full">
                      <!-- Request Form -->
                      @if (!isSubmitted) {
                        <div class="text-white-50 mb-4">
                          <h5 class="welcome-text">{{ 'ONBOARDING_REQUEST.TITLE' | translate }}</h5>
                          <p class="subtitle-text mt-2">{{ 'ONBOARDING_REQUEST.SUBTITLE' | translate }}</p>
                        </div>

                        <form [formGroup]="requestForm" (ngSubmit)="onSubmit()">
                          <!-- Hotel Information Section -->
                          <div class="form-section">
                            <h6 class="section-title">{{ 'ONBOARDING_REQUEST.HOTEL_INFO' | translate }}</h6>

                            <hc-form-field
                              [label]="'ONBOARDING_REQUEST.HOTEL_NAME' | translate"
                              [control]="requestForm.get('hotelName')"
                              [showErrorWhen]="submitted ? 'always' : 'touched'"
                              [customError]="'VALIDATION.REQUIRED' | translate: { field: ('ONBOARDING_REQUEST.HOTEL_NAME' | translate) }">
                              <hc-input type="text" [placeholder]="'ONBOARDING_REQUEST.HOTEL_NAME_PLACEHOLDER' | translate" formControlName="hotelName"></hc-input>
                            </hc-form-field>

                            <div class="row">
                              <div class="col-md-6">
                                <hc-form-field
                                  [label]="'ONBOARDING_REQUEST.CITY' | translate"
                                  [control]="requestForm.get('hotelCity')"
                                  [showErrorWhen]="submitted ? 'always' : 'touched'"
                                  [customError]="'VALIDATION.REQUIRED' | translate: { field: ('ONBOARDING_REQUEST.CITY' | translate) }">
                                  <hc-input type="text" [placeholder]="'ONBOARDING_REQUEST.CITY_PLACEHOLDER' | translate" formControlName="hotelCity"></hc-input>
                                </hc-form-field>
                              </div>
                              <div class="col-md-6">
                                <hc-form-field [label]="'ONBOARDING_REQUEST.COUNTRY' | translate">
                                  <hc-input-dropdown
                                    formControlName="hotelCountry"
                                    [options]="countryDropdownOptions"
                                    [placeholder]="'COMMON.SELECT' | translate">
                                  </hc-input-dropdown>
                                </hc-form-field>
                              </div>
                            </div>

                            <hc-form-field
                              [label]="'ONBOARDING_REQUEST.WEBSITE' | translate"
                              [control]="requestForm.get('hotelWebsite')">
                              <hc-input type="url" [placeholder]="'ONBOARDING_REQUEST.WEBSITE_PLACEHOLDER' | translate" formControlName="hotelWebsite"></hc-input>
                            </hc-form-field>
                          </div>

                          <!-- Contact Information Section -->
                          <div class="form-section">
                            <h6 class="section-title">{{ 'ONBOARDING_REQUEST.CONTACT_INFO' | translate }}</h6>

                            <hc-form-field
                              [label]="'ONBOARDING_REQUEST.CONTACT_NAME' | translate"
                              [control]="requestForm.get('contactName')"
                              [showErrorWhen]="submitted ? 'always' : 'touched'"
                              [customError]="'VALIDATION.REQUIRED' | translate: { field: ('ONBOARDING_REQUEST.CONTACT_NAME' | translate) }">
                              <hc-input type="text" [placeholder]="'ONBOARDING_REQUEST.CONTACT_NAME_PLACEHOLDER' | translate" formControlName="contactName"></hc-input>
                            </hc-form-field>

                            <hc-form-field
                              [label]="'ONBOARDING_REQUEST.CONTACT_EMAIL' | translate"
                              [control]="requestForm.get('contactEmail')"
                              [showErrorWhen]="submitted ? 'always' : 'touched'"
                              [customError]="'VALIDATION.EMAIL' | translate">
                              <hc-input type="email" [placeholder]="'ONBOARDING_REQUEST.CONTACT_EMAIL_PLACEHOLDER' | translate" formControlName="contactEmail"></hc-input>
                            </hc-form-field>

                            <div class="row">
                              <div class="col-md-6">
                                <hc-form-field
                                  [label]="'ONBOARDING_REQUEST.CONTACT_PHONE' | translate"
                                  [control]="requestForm.get('contactPhone')">
                                  <hc-input type="tel" [placeholder]="'ONBOARDING_REQUEST.CONTACT_PHONE_PLACEHOLDER' | translate" formControlName="contactPhone"></hc-input>
                                </hc-form-field>
                              </div>
                              <div class="col-md-6">
                                <hc-form-field [label]="'ONBOARDING_REQUEST.POSITION' | translate">
                                  <hc-input-dropdown
                                    formControlName="contactPosition"
                                    [options]="positionDropdownOptions"
                                    [placeholder]="'COMMON.SELECT' | translate">
                                  </hc-input-dropdown>
                                </hc-form-field>
                              </div>
                            </div>
                          </div>

                          <!-- Additional Information Section -->
                          <div class="form-section">
                            <h6 class="section-title">{{ 'ONBOARDING_REQUEST.ADDITIONAL_INFO' | translate }}</h6>

                            <hc-form-field
                              [label]="'ONBOARDING_REQUEST.MESSAGE' | translate"
                              [control]="requestForm.get('message')">
                              <hc-textarea
                                [placeholder]="'ONBOARDING_REQUEST.MESSAGE_PLACEHOLDER' | translate"
                                [rows]="3"
                                formControlName="message">
                              </hc-textarea>
                            </hc-form-field>

                            <hc-form-field [label]="'ONBOARDING_REQUEST.HOW_DID_YOU_HEAR' | translate">
                              <hc-input-dropdown
                                formControlName="howDidYouHear"
                                [options]="referralDropdownOptions"
                                [placeholder]="'COMMON.SELECT' | translate">
                              </hc-input-dropdown>
                            </hc-form-field>
                          </div>

                          <div class="mt-4">
                            <hc-button
                              variant="primary"
                              type="submit"
                              size="md"
                              [loading]="isSubmitting"
                              [disabled]="isSubmitting">
                              {{ isSubmitting ? ('ONBOARDING_REQUEST.SUBMITTING' | translate) : ('ONBOARDING_REQUEST.SUBMIT' | translate) }}
                            </hc-button>
                          </div>

                          <div class="mt-4 d-flex justify-content-center">
                            <p class="whitespace-nowrap">
                              {{ 'ONBOARDING_REQUEST.LOGIN_PROMPT' | translate }}
                            </p>
                            <a
                              routerLink="/account/login"
                              class="ms-2 fw-medium text-decoration-underline whitespace-nowrap register-hotel">
                              {{ 'ONBOARDING_REQUEST.LOGIN_LINK' | translate }}
                            </a>
                          </div>
                        </form>
                      }

                      <!-- Success State -->
                      @if (isSubmitted) {
                        <div class="success-state text-center">
                          <div class="success-icon mb-4">
                            <div class="success-icon__circle">
                              <lucide-icon name="circle-check" [size]="32"></lucide-icon>
                            </div>
                          </div>
                          <h5 class="welcome-text">{{ 'ONBOARDING_REQUEST.THANK_YOU_TITLE' | translate }}</h5>
                          <p class="mt-3 text-muted">{{ 'ONBOARDING_REQUEST.THANK_YOU_MESSAGE' | translate }}</p>
                          <div class="mt-4">
                            <a routerLink="/account/login" class="btn btn-outline-primary">
                              {{ 'ONBOARDING_REQUEST.BACK_TO_LOGIN' | translate }}
                            </a>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
